import { IconHelp, Text } from '@hudl/uniform-ui-components';
import React, { ReactNode, useEffect, useState } from 'react';
import * as styles from './styles.scss';

interface ErrorDisplayProps {
  children: ReactNode | null;
  qaId?: string;
}

const ErrorDisplay = (props: ErrorDisplayProps) => {
  const { children, qaId } = props;

  // Need to store the old errorType so we can transition out without having the content disappear
  const [internalError, setInternalError] = useState<ReactNode | null>(children);
  useEffect(() => {
    if (children === null) {
      setTimeout(() => {
        setInternalError(null);
      }, 500);
    } else {
      setInternalError(children);
    }
  }, [children]);

  return (
    <div className={`${styles.errorDisplayContainer} ${children ? styles.fadeInAndExpand : ''}`}>
      <div className={styles.errorDisplayInnerContainer}>
        <span className={styles.questionMarkContainer}>
          <IconHelp size="large" />
        </span>

        {/* Only show the qaId if we have an error, normally we would totally remove it from the DOM, but it makes animations harder */}
        <Text qaId={internalError ? qaId : undefined}>{internalError}</Text>
      </div>
    </div>
  );
};

export default ErrorDisplay;
